module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [(_vm.isSelectedTab('general-settings')) ? _c('div', [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("General Settings")])], 1), _vm._v(" "), _c('GeneralAppearance')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('email-settings')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Email Settings")])], 1), _vm._v(" "), _c('EmailSettings')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('opportunities')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Opportunities Settings")])], 1), _vm._v(" "), _c('Opportunities', {
    attrs: {
      "settings": _vm.pages.opportunities
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('directory')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Directory Settings")])], 1), _vm._v(" "), _c('Directory', {
    attrs: {
      "settings": _vm.pages.directory
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('questionnaire')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Questionnaire Settings")])], 1), _vm._v(" "), _c('Questionnaire', {
    attrs: {
      "settings": _vm.pages.questionnaire
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('history')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("History Settings")])], 1), _vm._v(" "), _c('History', {
    attrs: {
      "settings": _vm.pages.history
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('favorites')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Favorites Settings")])], 1), _vm._v(" "), _c('Favorites', {
    attrs: {
      "settings": _vm.pages.favorites
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('resources')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('Resources', {
    attrs: {
      "settings": _vm.pages.resources
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('bid_alerts')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Bid Alerts")])], 1), _vm._v(" "), _c('BidAlert', {
    attrs: {
      "settings": _vm.pages.bid_alerts || {}
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('tracking')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Tracking Settings")])], 1), _vm._v(" "), _c('Tracking', {
    attrs: {
      "settings": _vm.pages.tracking
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('dod-contract-analytics')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("DoD Contract Analytics Settings")])], 1), _vm._v(" "), _c('dod-contract-analytics', {
    attrs: {
      "settings": _vm.pages['dod-contract-analytics'] || {}
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41646b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/PagesView.vue
// module id = 1669
// module chunks = 2